import React from 'react';
import { Severity } from '@plerionhq/design-system';
import type { SeverityLevel } from '@plerionhq/design-system';
import AttachmentCardComponent, { type AttachmentRow } from './AttachmentCard';
import type { ContextItem } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

type FindingAttachment = {
  id?: string;
  severity?: string;
  service?: string;
  resourceType?: string;
  integrationName?: string;
  provider?: string;
  message?: string;
  isCdrFinding?: boolean;
};

export const FindingsContext: React.FC<{
  item: ContextItem;
  onRemove: () => void;
}> = ({ item, onRemove }) => {
  const { t } = useTranslation('pleri/chat');
  const finding = item.attachmentMetaData as FindingAttachment | undefined;
  if (!finding) {
    return null;
  }

  const { severity, resourceType, integrationName, message } = finding;
  const severityLevel = (severity || 'UNKNOWN').toUpperCase() as SeverityLevel;

  const rows: Array<AttachmentRow> = [];
  if (integrationName) {
    rows.push({ label: t('integration'), value: integrationName });
  }
  if (resourceType) {
    rows.push({ label: t('resource'), value: resourceType });
  }

  return (
    <AttachmentCardComponent
      icon={item.icon}
      title={message || t('finding')}
      rows={
        severity
          ? [
              {
                label: t('severity'),
                value: <Severity severityLevel={severityLevel} />,
              },
              ...rows,
            ]
          : rows
      }
      onRemove={onRemove}
      removeAriaLabel="Remove finding context"
    />
  );
};

export default FindingsContext;
